export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<tr class="' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'multi-value-row" ref="row">\n  <td class="' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'multi-value-row__input">\n    ' +
((__t = (ctx.element)) == null ? '' : __t) +
'\n  </td>\n  ';
 if (!ctx.disabled) { ;
__p += '\n  <td class="' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'multi-value-row__remove">\n    <button type="button" class="utrecht-button utrecht-button--subtle utrecht-button--danger" title="' +
((__t = (ctx.t('Remove'))) == null ? '' : __t) +
'" ref="removeRow">\n      <i class="' +
((__t = (ctx.iconClass('trash-can'))) == null ? '' : __t) +
'" aria-hidden="true"></i>\n      <span class="sr-only">' +
((__t = (ctx.t('Remove'))) == null ? '' : __t) +
'</span>\n    </button>\n  </td>\n  ';
 } ;
__p += '\n</tr>\n';
return __p
}